import Stack from '@/components/Custom/ModalStack';

export default function PrivateOrganizationJoinLayoutRoute() {
  return <Stack />;
}
